(() => {
  const KEY = 'btbGarageVehicleV6';
  const SESSION_KEY = 'btbGarageVehicleSessionV2';
  const COOKIE_KEY = 'btb_garage_vehicle_v2';
  const LAST_RESULTS_KEY = 'btbGarageLastResultsV2';
  const BROWSE_ALL_KEY = 'btbGarageBrowseAllSessionV1';
  const DEFAULT_SORT = 'price-ascending';
  const LEGACY_KEYS = ['btbGarageVehicleV5', 'btbGarageVehicleV4', 'btbGarageVehicleV3', 'btbGarageVehicleV2'];
  const STATE_KEYS = ['btb_vehicle','btb_series','btb_chassis','btb_model','btb_engine','btb_drivetrain','btb_years'];
  const CONTEXT_KEYS = ['btb_category','btb_q','btb_change_vehicle'];
  const TRACKING_KEYS = ['_pos','_sid','_ss'];
  const PLATFORM_PARAM = 'btb_platform';
  const CATEGORY_BY_COLLECTION = {
    // 11.7.41: recognise canonical category URLs alongside legacy handles.
    'bmw-tuning-software':'BT-CAT-TUNING',
    'bmw-fuel-delivery':'BT-CAT-FUEL',
    'bmw-turbo-upgrades':'BT-CAT-TURBO',
    'bmw-performance-exhaust':'BT-CAT-EXHAUST',
    'bmw-service-maintenance':'BT-CAT-SERVICE',
    'tuning-software':'BT-CAT-TUNING',
    'tuning-and-software-upgrades':'BT-CAT-TUNING',
    'intake':'BT-CAT-INTAKE',
    'fuel-delivery':'BT-CAT-FUEL',
    'turbochargers':'BT-CAT-TURBO',
    'exhaust':'BT-CAT-EXHAUST',
    'suspension':'BT-CAT-SUSPENSION',
    'brakes':'BT-CAT-BRAKES',
    'aero':'BT-CAT-AERO',
    'engine':'BT-CAT-ENGINE',
    'transmission':'BT-CAT-TRANSMISSION',
    'body':'BT-CAT-BODY',
    'service-maintenance':'BT-CAT-SERVICE'
  };

  // SEO landing routes. Vehicle-specific Parts Finder sessions should live on a
  // stable, crawlable BMW model/engine collection rather than /collections/all.
  const MODEL_LANDING_BY_CHASSIS = {
    G87:'/collections/bmw-g87-m2-performance-parts',
    G80:'/collections/bmw-g80-m3-performance-parts',
    G81:'/collections/bmw-g81-m3-touring-performance-parts',
    G82:'/collections/bmw-g82-m4-performance-parts',
    G83:'/collections/bmw-g83-m4-convertible-performance-parts',
    F97:'/collections/bmw-f97-x3m-performance-parts',
    F98:'/collections/bmw-f98-x4m-performance-parts',
    F90:'/collections/bmw-f90-m5-performance-parts'
  };
  const ENGINE_LANDING = {
    S58:'/collections/bmw-s58-performance-parts',
    B58:'/collections/bmw-b58-performance-parts',
    S63:'/collections/bmw-s63-performance-parts',
    N54:'/collections/n54',
    N55:'/collections/n55',
    S55:'/collections/s55'
  };

  const vehicles = () => Array.isArray(window.BTB_VEHICLES) ? window.BTB_VEHICLES : [];
  const unique = arr => [...new Set(arr.filter(Boolean))].sort((a,b) => a.localeCompare(b, undefined, {numeric:true}));
  const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const handleize = value => String(value || '').trim().toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const codes = value => String(value || '').split('/').map(x => x.trim()).filter(Boolean);
  const baseEngines = value => {
    const found = String(value || '').toUpperCase().match(/\b(?:B|N|S|M)\d{2}(?:B\d{2}[A-Z0-9]*)?\b/g) || [];
    const tokens = new Set();
    found.forEach(token => {
      tokens.add(token);
      if (/^(?:B|N|S|M)\d{2}/.test(token)) tokens.add(token.slice(0, 3));
    });
    return [...tokens];
  };
  const drivetrainTokens = value => {
    const tokens = new Set();
    String(value || '').toUpperCase().split(/[;,|/]+/).forEach(part => {
      if (/\bRWD\b/.test(part)) tokens.add('RWD');
      if (/\bFWD\b/.test(part)) tokens.add('FWD');
      if (/\bAWD\b/.test(part) || /\bXDRIVE\b/.test(part)) tokens.add('AWD');
    });
    return [...tokens];
  };
  const yearRanges = value => {
    const ranges = [];
    const parts = Array.isArray(value) ? value : String(value || '').split(/[;,|]+/);
    parts.forEach(part => {
      const text = String(part || '').replace(/[–—−]/g, '-').trim();
      const years = (text.match(/\b(?:19|20)\d{2}\b/g) || []).map(Number);
      if (!years.length) return;
      const start = years[0];
      let end = years.length > 1 ? years[1] : start;
      if (/\b(?:present|current|onward|onwards)\b/i.test(text) || /\d{4}\s*\+$/.test(text)) end = 9999;
      ranges.push({start, end: Math.max(start, end)});
    });
    return ranges;
  };
  const yearRangesOverlap = (a, b) => a.some(x => b.some(y => x.start <= y.end && y.start <= x.end));

  const normaliseSpecificModel = value => String(value || '')
    .toLowerCase()
    .replace(/\bbmw\b/g, ' ')
    .replace(/\b(?:e|f|g|i|u)\d{2,3}(?:\s+lci)?\b/g, ' ')
    .replace(/\bxdrive\b/g, ' ')
    .replace(/\b(?:sedan|coupe|convertible|touring|gran coupe|compact|roadster|suv|hatch|wagon)\b/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const numericModelTokens = input => {
    const tokens = new Set();
    const values = Array.isArray(input) ? input : String(input || '').split(/[;,|]+/);
    values.forEach(value => {
      const cleaned = normaliseSpecificModel(value);
      const matches = cleaned.match(/\b(?:m\d{2,3}[a-z]?|\d{3}[a-z]{1,3}|(?:sdrive|xdrive)\d+[a-z]+|z4\s+\d\.\d[a-z]*|x5\s+\d\.\d[a-z]*)\b/gi) || [];
      matches.forEach(token => {
        let normal = token.toLowerCase().replace(/\s+/g, '');
        normal = normal.replace(/^(?:z4|x5)/, '');
        tokens.add(normal);
      });
    });
    return [...tokens];
  };

  const selectedNumericModelTokens = vehicle => {
    const tokens = new Set();
    const cleaned = normaliseSpecificModel(vehicle?.model || '');
    const matches = cleaned.match(/\b(?:m\d{2,3}[a-z]?|\d{3}[a-z]{1,3}|(?:sdrive|xdrive)\d+[a-z]+|z4\s+\d\.\d[a-z]*|x5\s+\d\.\d[a-z]*)\b/gi) || [];
    matches.forEach(token => {
      let normal = token.toLowerCase().replace(/\s+/g, '');
      normal = normal.replace(/^(?:z4|x5)/, '');
      tokens.add(normal);
      if (/^m\d{3}$/.test(normal)) tokens.add(`${normal}i`);
    });
    return [...tokens].filter(Boolean);
  };

  const productPageScopeMatch = (vehicle, product, models, chassis) => {
    const title = String(product?.dataset?.btbProductTitle || '');
    const selectedText = `${vehicle?.series || ''} ${vehicle?.model || ''} ${vehicle?.body || ''}`;
    const bodyTerms = ['convertible', 'compact', 'gran coupe', 'touring', 'roadster'];
    for (const term of bodyTerms) {
      if (title.toLowerCase().includes(term) && !selectedText.toLowerCase().includes(term)) return false;
    }
    if (/\bnon[- ]m\b/i.test(title) &&
        /\b(?:m[234568]|x[1-7]\s*m|1\s*series\s*m)\b/i.test(selectedText)) return false;
    if (/\b1m\b/i.test(title) &&
        !(/\b1m\b/i.test(selectedText) || /\b1\s*series\s*m\b/i.test(selectedText))) return false;
    if (chassis.length > 0 && chassis.length <= 2) {
      const productModels = numericModelTokens(models);
      if (productModels.length) {
        const selectedModels = selectedNumericModelTokens(vehicle);
        if (!selectedModels.some(model => productModels.includes(model))) return false;
      }
    }
    return true;
  };
  const vehicleKey = v => [v?.series,v?.chassis,v?.model,v?.body,v?.years,v?.engine,v?.drivetrain].map(x => x || '').join('|');
  const label = v => v ? `${v.model || v.series} · ${v.chassis} · ${v.engine}` : '';


  function vehicleLandingPath(vehicle) {
    if (!vehicle) return '/collections/all';
    const chassis = exactChassisCodes(vehicle.chassis)[0] || String(vehicle.chassis || '').toUpperCase();
    if (MODEL_LANDING_BY_CHASSIS[chassis]) return MODEL_LANDING_BY_CHASSIS[chassis];

    const engines = baseEngines(vehicle.engine).map(x => String(x).toUpperCase());
    if (engines.some(x => x.startsWith('S58'))) return ENGINE_LANDING.S58;
    if (engines.some(x => x.startsWith('B58'))) return ENGINE_LANDING.B58;
    if (engines.some(x => x.startsWith('S63'))) return ENGINE_LANDING.S63;
    if (engines.some(x => x.startsWith('N54'))) return ENGINE_LANDING.N54;
    if (engines.some(x => x.startsWith('N55'))) return ENGINE_LANDING.N55;
    if (engines.some(x => x.startsWith('S55'))) return ENGINE_LANDING.S55;
    return '/collections/all';
  }

  // Shared-platform tokens are umbrella identifiers only. Sibling chassis are never
  // treated as interchangeable. Example: G87 can match G87 or G8X, but not G80.
  const sharedPlatformTokens = {
    G80:['G8X'], G81:['G8X'], G82:['G8X'], G83:['G8X'], G87:['G8X'],
    F80:['F8X'], F82:['F8X'], F83:['F8X'],
    E90:['E9X'], E91:['E9X'], E92:['E9X'], E93:['E9X'],
    F20:['F2X'], F21:['F2X'], F22:['F2X'], F23:['F2X'],
    F30:['F3X'], F31:['F3X'], F32:['F3X'], F33:['F3X'], F34:['F3X'], F36:['F3X'],
    G20:['G2X'], G21:['G2X'], G22:['G2X'], G23:['G2X'], G26:['G2X'],
    F97:['F97/F98','F97-F98'], F98:['F97/F98','F97-F98'],
    F95:['F95/F96','F95-F96'], F96:['F95/F96','F95-F96'],
    G01:['G01/G02','G01-G02'], G02:['G01/G02','G01-G02'],
    G05:['G05/G06/G07','G05-G06-G07'], G06:['G05/G06/G07','G05-G06-G07'], G07:['G05/G06/G07','G05-G06-G07'],
    F10:['F10/F11','F10-F11'], F11:['F10/F11','F10-F11']
  };

  function exactChassisCodes(chassis) {
    const raw = codes(chassis).map(x => x.toUpperCase());
    const exact = new Set(raw);
    raw.forEach(code => {
      const base = code.replace(/\s+LCI$/i, '').trim();
      if (base) exact.add(base);
    });
    return [...exact].filter(Boolean);
  }

  function chassisAliases(chassis) {
    const exact = exactChassisCodes(chassis);
    const aliases = new Set(exact);
    exact.forEach(code => (sharedPlatformTokens[code] || []).forEach(token => aliases.add(token)));
    return [...aliases].filter(Boolean);
  }

  function isBrowseAllMode() {
    try { return sessionStorage.getItem(BROWSE_ALL_KEY) === '1'; }
    catch (_) { return false; }
  }

  function setBrowseAllMode(enabled) {
    try {
      if (enabled) sessionStorage.setItem(BROWSE_ALL_KEY, '1');
      else sessionStorage.removeItem(BROWSE_ALL_KEY);
    } catch (_) {}
  }

  function removeFinderState(url, options = {}) {
    const removeContext = options.removeContext !== false;
    STATE_KEYS.forEach(key => url.searchParams.delete(key));
    if (removeContext) CONTEXT_KEYS.forEach(key => url.searchParams.delete(key));
    return url;
  }

  function addDefaultCollectionSort(url) {
    if (/^\/collections\/[^/?#]+/.test(url.pathname) && !url.searchParams.has('sort_by')) {
      url.searchParams.set('sort_by', DEFAULT_SORT);
    }
    return url;
  }

  function cleanUrlString(url) {
    return url.origin === window.location.origin
      ? `${url.pathname}${url.search}${url.hash}`
      : url.toString();
  }

  function browseAllUrl() {
    const url = new URL('/collections/all', window.location.origin);
    url.searchParams.set('sort_by', DEFAULT_SORT);
    return cleanUrlString(url);
  }

  function scrubCurrentUrl() {
    try {
      const url = new URL(window.location.href);
      removeFinderState(url);
      TRACKING_KEYS.forEach(key => url.searchParams.delete(key));
      addDefaultCollectionSort(url);
      const clean = cleanUrlString(url);
      const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      if (clean !== current) window.history.replaceState(window.history.state, '', clean);
    } catch (_) {}
  }

  function setCookie(vehicle) {
    try {
      const value = encodeURIComponent(JSON.stringify(vehicle));
      document.cookie = `${COOKIE_KEY}=${value}; path=/; max-age=31536000; SameSite=Lax`;
    } catch (_) {}
  }

  function getCookie() {
    try {
      const prefix = `${COOKIE_KEY}=`;
      const part = document.cookie.split(';').map(x => x.trim()).find(x => x.startsWith(prefix));
      return part ? JSON.parse(decodeURIComponent(part.slice(prefix.length))) : null;
    } catch (_) {
      return null;
    }
  }

  function clearCookie() {
    document.cookie = `${COOKIE_KEY}=; path=/; max-age=0; SameSite=Lax`;
  }

  function vehicleFromParams(input = window.location.href) {
    if (isBrowseAllMode()) return null;
    try {
      const url = new URL(input, window.location.origin);
      const params = url.searchParams;
      if (!params.has('btb_vehicle') && !params.has('btb_chassis')) return null;

      const key = params.get('btb_vehicle') || '';
      const exact = vehicles().find(v => vehicleKey(v) === key);
      if (exact) return exact;

      const recovered = {
        series: params.get('btb_series') || '',
        chassis: params.get('btb_chassis') || '',
        model: params.get('btb_model') || '',
        body: '',
        engine: params.get('btb_engine') || '',
        drivetrain: params.get('btb_drivetrain') || '',
        years: params.get('btb_years') || ''
      };

      // Re-hydrate a complete canonical vehicle object whenever the URL contains
      // the split btb_* fields but the composite btb_vehicle key was dropped or
      // altered by collection navigation. This preserves the exact model variant,
      // including body/year/engine/drivetrain details used by vehicleKey().
      const canonical = vehicles().find(v =>
        (!recovered.series || v.series === recovered.series) &&
        (!recovered.chassis || v.chassis === recovered.chassis) &&
        (!recovered.model || v.model === recovered.model) &&
        (!recovered.engine || v.engine === recovered.engine) &&
        (!recovered.drivetrain || v.drivetrain === recovered.drivetrain) &&
        (!recovered.years || v.years === recovered.years)
      );
      if (canonical) return canonical;

      return recovered.chassis && (recovered.model || recovered.series) ? recovered : null;
    } catch (_) {
      return null;
    }
  }

  function readStored() {
    const stores = [
      () => localStorage.getItem(KEY),
      () => sessionStorage.getItem(SESSION_KEY),
      ...LEGACY_KEYS.map(key => () => localStorage.getItem(key))
    ];
    for (const read of stores) {
      try {
        const value = read();
        if (value) {
          const parsed = JSON.parse(value);
          if (parsed?.chassis) return parsed;
        }
      } catch (_) {}
    }
    return getCookie();
  }

  function getGarage() {
    if (isBrowseAllMode()) return null;

    const fromUrl = vehicleFromParams();
    const stored = readStored();
    if (!fromUrl) return stored;

    // A fully encoded btb_vehicle key is authoritative. If collection navigation
    // left only partial split fields, prefer the saved canonical garage vehicle
    // when it is the same chassis/model family so the exact selected variant is
    // not silently downgraded.
    try {
      const params = new URLSearchParams(window.location.search);
      const composite = params.get('btb_vehicle') || '';
      if (composite && vehicles().some(v => vehicleKey(v) === composite)) return fromUrl;
    } catch (_) {}

    if (stored && String(stored.chassis || '') === String(fromUrl.chassis || '')) {
      const sameModel = !fromUrl.model || !stored.model || stored.model === fromUrl.model;
      const sameSeries = !fromUrl.series || !stored.series || stored.series === fromUrl.series;
      if (sameModel || sameSeries) return stored;
    }
    return fromUrl;
  }

  function saveGarage(vehicle, options = {}) {
    if (!vehicle?.chassis) return;
    setBrowseAllMode(false);
    const payload = JSON.stringify(vehicle);
    try { localStorage.setItem(KEY, payload); } catch (_) {}
    try { sessionStorage.setItem(SESSION_KEY, payload); } catch (_) {}
    setCookie(vehicle);
    LEGACY_KEYS.forEach(key => {
      try { localStorage.removeItem(key); } catch (_) {}
    });
    if (!options.keepLastResults) {
      try {
        const saved = JSON.parse(localStorage.getItem(LAST_RESULTS_KEY) || 'null');
        if (saved && saved.vehicleKey !== vehicleKey(vehicle)) localStorage.removeItem(LAST_RESULTS_KEY);
      } catch (_) {}
    }
    if (!options.silent) {
      document.dispatchEvent(new CustomEvent('btb:garage-change', {detail: vehicle}));
    }
  }

  function restoreNode(node) {
    if (!(node instanceof Element)) return;
    const anchors = node.matches('a[data-btb-original-href]') ? [node] : [...node.querySelectorAll('a[data-btb-original-href]')];
    anchors.forEach(anchor => {
      const original = anchor.dataset.btbOriginalHref;
      if (original) anchor.setAttribute('href', original);
      delete anchor.dataset.btbOriginalHref;
    });

    const dataUrls = node.matches('[data-product-url],[data-connected-product-url]')
      ? [node]
      : [...node.querySelectorAll('[data-product-url],[data-connected-product-url]')];
    dataUrls.forEach(el => {
      ['productUrl','connectedProductUrl'].forEach(key => {
        const originalKey = `btbOriginal${key.charAt(0).toUpperCase()}${key.slice(1)}`;
        if (el.dataset[originalKey]) {
          el.dataset[key] = el.dataset[originalKey];
          delete el.dataset[originalKey];
        }
      });
    });
  }

  function restoreDocument() {
    restoreNode(document.documentElement);
  }

  function clearGarage(options = {}) {
    [KEY, ...LEGACY_KEYS].forEach(key => {
      try { localStorage.removeItem(key); } catch (_) {}
    });
    try {
      sessionStorage.removeItem(SESSION_KEY);
      localStorage.removeItem(LAST_RESULTS_KEY);
    } catch (_) {}
    clearCookie();
    setBrowseAllMode(true);
    restoreDocument();
    scrubCurrentUrl();
    document.dispatchEvent(new CustomEvent('btb:garage-change', {detail: null}));

    if (options.navigate) {
      window.location.assign(browseAllUrl());
    }
  }

  function resetGarageForPlatformChange() {
    [KEY, ...LEGACY_KEYS].forEach(key => {
      try { localStorage.removeItem(key); } catch (_) {}
    });
    try {
      sessionStorage.removeItem(SESSION_KEY);
      localStorage.removeItem(LAST_RESULTS_KEY);
    } catch (_) {}
    clearCookie();
    setBrowseAllMode(false);
  }

  function appendState(url, vehicle, extras = {}) {
    if (!vehicle?.chassis) return url;
    const params = url.searchParams;
    const state = {
      btb_vehicle: vehicleKey(vehicle),
      btb_series: vehicle.series || '',
      btb_chassis: vehicle.chassis || '',
      btb_model: vehicle.model || '',
      btb_engine: vehicle.engine || '',
      btb_drivetrain: vehicle.drivetrain || '',
      btb_years: vehicle.years || ''
    };
    Object.entries(state).forEach(([key, value]) => value ? params.set(key, value) : params.delete(key));
    if (extras.categoryTag) params.set('btb_category', extras.categoryTag);
    if (extras.searchTerm) params.set('btb_q', extras.searchTerm);
    if (extras.preserveContext === true) {
      const current = new URLSearchParams(window.location.search);
      ['btb_category','btb_q'].forEach(key => {
        if (!params.has(key) && current.has(key)) params.set(key, current.get(key));
      });
    }
    return url;
  }

  function resultsUrl(vehicle, categoryTag = '', searchTerm = '', sortBy = '') {
    if (!vehicle) return '/collections/all';
    const url = new URL(vehicleLandingPath(vehicle), window.location.origin);
    const currentParams = new URLSearchParams(window.location.search);
    const currentSort = currentParams.get('sort_by');
    url.searchParams.set('sort_by', sortBy || currentSort || DEFAULT_SORT);
    const previewThemeId = currentParams.get('preview_theme_id');
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    appendState(url, vehicle, {categoryTag, searchTerm});
    return `${url.pathname}${url.search}`;
  }

  function collectionCategory(pathname) {
    const match = String(pathname || '').match(/^\/collections\/([^/?#]+)/);
    return match ? CATEGORY_BY_COLLECTION[handleize(match[1])] || '' : '';
  }

  function isInternal(url) {
    return url.origin === window.location.origin ||
      url.hostname.endsWith('.myshopify.com') ||
      url.hostname === window.location.hostname;
  }

  function withState(rawUrl, vehicle = getGarage(), options = {}) {
    if (!vehicle || !rawUrl) return rawUrl;
    const raw = String(rawUrl);
    if (/^(?:mailto:|tel:|sms:|javascript:|#)/i.test(raw)) return raw;

    let url;
    try { url = new URL(raw, window.location.href); } catch (_) { return raw; }
    if (!isInternal(url)) return raw;
    if (/^\/(?:cart|checkout|account|admin)(?:\/|$)/.test(url.pathname)) return raw;

    if (url.pathname === '/search') {
      const q = url.searchParams.get('q') || options.searchTerm || '';
      return resultsUrl(vehicle, '', q, url.searchParams.get('sort_by') || '');
    }

    // Never allow a category/search from a previous results page to leak into
    // unrelated navigation. Category links and fitment search add their own
    // context explicitly.
    removeFinderState(url);
    if (url.pathname === '/collections/all') url.pathname = vehicleLandingPath(vehicle);
    addDefaultCollectionSort(url);

    const categoryTag = options.categoryTag || collectionCategory(url.pathname);
    appendState(url, vehicle, {
      categoryTag,
      searchTerm: options.searchTerm || '',
      preserveContext: options.preserveContext === true
    });

    return cleanUrlString(url);
  }

  function rememberLastResults(url = window.location.href, vehicle = getGarage()) {
    if (!vehicle) return;
    try {
      const parsed = new URL(url, window.location.origin);
      localStorage.setItem(LAST_RESULTS_KEY, JSON.stringify({
        vehicleKey: vehicleKey(vehicle),
        url: `${parsed.pathname}${parsed.search}${parsed.hash}`
      }));
    } catch (_) {}
  }

  function lastResultsUrl(vehicle = getGarage()) {
    if (!vehicle) return browseAllUrl();
    try {
      const saved = JSON.parse(localStorage.getItem(LAST_RESULTS_KEY) || 'null');
      if (saved?.vehicleKey === vehicleKey(vehicle) && saved.url) {
        const url = new URL(saved.url, window.location.origin);
        if (url.pathname === '/collections/all') {
          const savedURL = new URL(saved.url, window.location.origin);
          return resultsUrl(
            vehicle,
            savedURL.searchParams.get('btb_category') || '',
            savedURL.searchParams.get('btb_q') || '',
            savedURL.searchParams.get('sort_by') || DEFAULT_SORT
          );
        }
        if (url.origin === window.location.origin && /^\/collections\//.test(url.pathname)) {
          return cleanUrlString(addDefaultCollectionSort(url));
        }
      }
    } catch (_) {}
    return resultsUrl(vehicle);
  }

  function initFinder(root) {
    const series = root.querySelector('[data-btb-series]');
    const chassis = root.querySelector('[data-btb-chassis]');
    const variant = root.querySelector('[data-btb-variant]');
    const button = root.querySelector('[data-btb-submit]');
    const turboButton = root.querySelector('[data-btb-turbo-submit]');
    const status = root.querySelector('[data-btb-status]');
    const clear = root.querySelector('[data-btb-clear]');
    if (!series || !chassis || !variant || !button || root.dataset.btbInitialised === 'true') return;
    root.dataset.btbInitialised = 'true';

    const data = vehicles();
    const fill = (select, values, placeholder) => {
      select.innerHTML = `<option value="">${escapeHtml(placeholder)}</option>` +
        values.map(v => `<option value="${escapeHtml(v)}">${escapeHtml(v)}</option>`).join('');
      select.disabled = !values.length;
    };

    fill(series, unique(data.map(v => v.series)), 'Choose BMW model range');
    fill(chassis, [], 'Choose chassis');
    fill(variant, [], 'Choose exact variant');

    const loadChassis = () => {
      fill(chassis, unique(data.filter(v => v.series === series.value).map(v => v.chassis)), 'Choose chassis');
      fill(variant, [], 'Choose exact variant');
    };
    const loadVariants = () => {
      const matches = data.filter(v => v.series === series.value && v.chassis === chassis.value);
      variant.innerHTML = '<option value="">Choose exact model, year, engine and drivetrain</option>' + matches.map(v =>
        `<option value="${escapeHtml(vehicleKey(v))}">${escapeHtml(v.model)} — ${escapeHtml(v.years)} — ${escapeHtml(v.engine)} — ${escapeHtml(v.drivetrain)}</option>`
      ).join('');
      variant.disabled = !matches.length;
    };

    series.addEventListener('change', loadChassis);
    chassis.addEventListener('change', loadVariants);

    const remembered = getGarage();
    if (remembered) {
      series.value = remembered.series || '';
      loadChassis();
      chassis.value = remembered.chassis || '';
      loadVariants();
      variant.value = vehicleKey(remembered);
      if (status) status.textContent = `My Garage: ${label(remembered)}`;
    }

    const requestedPlatform = String(new URLSearchParams(window.location.search).get(PLATFORM_PARAM) || '').toUpperCase();
    if (requestedPlatform) {
      const platformVehicle = data.find(v => exactChassisCodes(v.chassis).includes(requestedPlatform));
      if (platformVehicle) {
        series.value = platformVehicle.series || '';
        loadChassis();
        chassis.value = platformVehicle.chassis || '';
        loadVariants();
        variant.value = '';
        if (status) status.textContent = `Choose the exact ${requestedPlatform} model, year, engine and drivetrain.`;
        setTimeout(() => variant.focus({preventScroll:true}), 180);
      }
    }

    const navigateFromFinder = (categoryTag = '') => {
      const picked = data.find(v => vehicleKey(v) === variant.value);
      if (!picked) {
        if (status) status.textContent = 'Select the model range, chassis and exact variant first.';
        return;
      }
      saveGarage(picked);
      window.location.assign(resultsUrl(picked, categoryTag));
    };

    button.addEventListener('click', () => navigateFromFinder());
    turboButton?.addEventListener('click', () => navigateFromFinder('BT-CAT-TURBO'));

    clear?.addEventListener('click', () => {
      clearGarage({navigate:true});
    });
  }

  function openFinder() {
    const finder = document.querySelector('[data-btb-parts-finder]');
    if (finder) {
      finder.scrollIntoView({behavior:'smooth', block:'center'});
      finder.querySelector('select')?.focus({preventScroll:true});
      return;
    }
    const vehicle = getGarage();
    const url = new URL('/', window.location.origin);
    if (vehicle) appendState(url, vehicle);
    url.searchParams.set('btb_change_vehicle', '1');
    url.hash = 'btb-parts-finder';
    window.location.assign(`${url.pathname}${url.search}${url.hash}`);
  }

  function updateCategoryLinks(vehicle) {
    document.querySelectorAll('[data-btb-category-all]').forEach(link => {
      if (vehicle) link.href = resultsUrl(vehicle);
      else {
        const url = new URL(link.dataset.baseUrl || '/collections/all', window.location.origin);
        addDefaultCollectionSort(url);
        link.href = cleanUrlString(url);
      }
    });
    document.querySelectorAll('[data-btb-category-link]').forEach(link => {
      const categoryTag = link.dataset.categoryTag || '';
      if (vehicle) link.href = resultsUrl(vehicle, categoryTag);
      else {
        const url = new URL(link.dataset.baseUrl || '/collections/all', window.location.origin);
        addDefaultCollectionSort(url);
        link.href = cleanUrlString(url);
      }
      if (vehicle) link.title = `Show ${link.textContent.trim()} for ${label(vehicle)}`;
      else link.removeAttribute('title');
    });
  }

  function updateGlobal(vehicle) {
    document.querySelectorAll('[data-btb-garage-context]').forEach(el => { el.hidden = !vehicle; });
    document.querySelectorAll('[data-btb-garage-label]').forEach(el => {
      el.textContent = vehicle ? label(vehicle) : 'Select your BMW';
    });
    document.querySelectorAll('[data-btb-garage-search]').forEach(el => {
      el.hidden = !vehicle;
      if (vehicle) {
        el.href = lastResultsUrl(vehicle);
        if (el.dataset.btbDynamicText !== 'false') {
          el.textContent = location.pathname.startsWith('/products/') ? 'Back to compatible parts' : 'Shop compatible parts';
        }
      }
    });
    document.querySelectorAll('[data-btb-garage-clear]').forEach(el => { el.hidden = !vehicle; });
    if (vehicle) {
      updateCategoryLinks(vehicle);
      decorateDocument(vehicle);
    } else {
      restoreDocument();
      updateCategoryLinks(null);
      const fitmentResults = document.querySelector('[data-btb-fitment-results]');
      const defaultGrid = document.querySelector('[data-btb-default-collection-grid]');
      if (fitmentResults) fitmentResults.hidden = true;
      if (defaultGrid) defaultGrid.hidden = false;
    }

    const product = document.querySelector('[data-btb-product-fitment]');
    const verdict = document.querySelector('[data-btb-fit-verdict]');
    if (product && verdict) {
      if (!vehicle) {
        verdict.className = 'btb-fit-verdict is-neutral';
        verdict.textContent = 'Select a BMW to check this product.';
        return;
      }
      let chassis = [], engines = [], drivetrains = [], years = [], models = [];
      try {
        chassis = JSON.parse(product.dataset.btbChassis || '[]');
        engines = JSON.parse(product.dataset.btbEngines || '[]');
        drivetrains = JSON.parse(product.dataset.btbDrivetrains || '[]');
        years = JSON.parse(product.dataset.btbYears || '[]');
        models = JSON.parse(product.dataset.btbModels || '[]');
      } catch (_) {}
      const productChassis = chassis.map(x => String(x).toUpperCase());
      const productEngines = baseEngines(engines.join(' / '));
      const engineWide = String(product.dataset.btbEngineWide || '').toLowerCase() === 'true';
      const rawChassisMatch = chassisAliases(vehicle.chassis).some(c => productChassis.includes(c));
      const vehicleEngines = baseEngines(vehicle.engine);
      const eMatch = productEngines.length === 0 || vehicleEngines.length === 0 ||
        vehicleEngines.some(e => productEngines.includes(e));
      const cMatch = engineWide ? eMatch : rawChassisMatch;
      const pDrive = drivetrainTokens(drivetrains.join(' / '));
      const vDrive = drivetrainTokens(vehicle.drivetrain);
      const dMatch = pDrive.length === 0 || vDrive.length === 0 || vDrive.some(d => pDrive.includes(d));
      const pYears = yearRanges(years);
      const vYears = yearRanges(vehicle.years);
      const yMatch = pYears.length === 0 || vYears.length === 0 || yearRangesOverlap(vYears, pYears);
      const mMatch = productPageScopeMatch(vehicle, product, models, chassis);

      if (cMatch && eMatch && dMatch && yMatch && mMatch) {
        verdict.className = 'btb-fit-verdict is-fit';
        verdict.textContent = engineWide
          ? `Confirmed ${productEngines.join(' / ')} engine-family fitment for your ${vehicle.model}.`
          : `Confirmed chassis, engine, drivetrain and production-year match for your ${vehicle.model}.`;
      } else if (cMatch || (engineWide && eMatch)) {
        verdict.className = 'btb-fit-verdict is-check';
        const failed = [];
        if (!eMatch) failed.push('engine');
        if (!dMatch) failed.push('drivetrain');
        if (!yMatch) failed.push('production year');
        if (!mMatch) failed.push('model/body variant');
        verdict.textContent = failed.length
          ? `Chassis family matches, but published ${failed.join(', ')} fitment does not match your saved BMW.`
          : 'Compatible chassis family found; confirm options before ordering.';
      } else {
        verdict.className = 'btb-fit-verdict is-no';
        verdict.textContent = `No published fitment match for your ${vehicle.model}. Contact M Lab by Boost & Tune before ordering.`;
      }
    }
  }

  function decorateNode(node, vehicle) {
    if (!(node instanceof Element) || !vehicle) return;
    const anchors = node.matches('a[href]') ? [node] : [...node.querySelectorAll('a[href]')];
    anchors.forEach(anchor => {
      if (anchor.hasAttribute('download') || anchor.target === '_blank') return;
      if (anchor.matches('[data-btb-garage-search],[data-btb-category-link],[data-btb-category-all],[data-btb-platform-card]')) return;
      const original = anchor.dataset.btbOriginalHref || anchor.getAttribute('href');
      if (!original) return;
      anchor.dataset.btbOriginalHref = original;
      const updated = withState(original, vehicle);
      if (updated) anchor.setAttribute('href', updated);
    });

    const dataUrls = node.matches('[data-product-url],[data-connected-product-url]')
      ? [node]
      : [...node.querySelectorAll('[data-product-url],[data-connected-product-url]')];
    dataUrls.forEach(el => {
      ['productUrl','connectedProductUrl'].forEach(key => {
        if (!el.dataset[key]) return;
        const originalKey = `btbOriginal${key.charAt(0).toUpperCase()}${key.slice(1)}`;
        const original = el.dataset[originalKey] || el.dataset[key];
        el.dataset[originalKey] = original;
        el.dataset[key] = withState(original, vehicle);
      });
    });
  }

  let decorateQueued = false;
  function decorateDocument(vehicle = getGarage()) {
    if (!vehicle || decorateQueued) return;
    decorateQueued = true;
    requestAnimationFrame(() => {
      decorateQueued = false;
      decorateNode(document.documentElement, vehicle);
    });
  }

  function bindGlobalEvents() {
    document.addEventListener('click', event => {
      const platformCard = event.target.closest('a[data-btb-platform-card]');
      if (platformCard) {
        const targetChassis = String(platformCard.dataset.btbPlatformChassis || '').toUpperCase();

        // Platform cards are an intentional vehicle-selection entry point, not a
        // shortcut to the previously saved car. Always open the Parts Finder with
        // the clicked chassis preselected so the shopper chooses the exact model,
        // production range, engine and drivetrain. Once chosen, My Garage remains
        // authoritative while browsing collections.
        if (targetChassis) {
          event.preventDefault();
          event.stopPropagation();
          resetGarageForPlatformChange();
          const url = new URL('/', window.location.origin);
          url.searchParams.set(PLATFORM_PARAM, targetChassis);
          url.searchParams.set('btb_change_vehicle', '1');
          url.hash = 'btb-parts-finder';
          window.location.assign(`${url.pathname}${url.search}${url.hash}`);
          return;
        }
      }

      const open = event.target.closest('[data-btb-garage-open]');
      if (open) {
        event.preventDefault();
        openFinder();
        return;
      }

      const clear = event.target.closest('[data-btb-garage-clear]');
      if (clear) {
        event.preventDefault();
        clearGarage({navigate:true});
        return;
      }

      const anchor = event.target.closest('a[href]');
      const vehicle = getGarage();
      if (!anchor || !vehicle) return;
      if (anchor.matches('[data-btb-garage-search],[data-btb-category-link],[data-btb-category-all],[data-btb-platform-card]')) return;
      const original = anchor.dataset.btbOriginalHref || anchor.getAttribute('href');
      const updated = withState(original, vehicle);
      if (updated) anchor.setAttribute('href', updated);
    }, true);

    document.addEventListener('submit', event => {
      const form = event.target.closest('form[action]');
      const vehicle = getGarage();
      if (!form || !vehicle) return;
      let action;
      try { action = new URL(form.getAttribute('action') || '', window.location.href); } catch (_) { return; }
      if (action.pathname !== '/search') return;
      const q = String(new FormData(form).get('q') || '').trim();
      event.preventDefault();
      window.location.assign(resultsUrl(vehicle, '', q));
    }, true);

    const observer = new MutationObserver(mutations => {
      const vehicle = getGarage();
      if (!vehicle) return;
      mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
        if (node instanceof Element) decorateNode(node, vehicle);
      }));
    });
    observer.observe(document.documentElement, {childList:true, subtree:true});

    window.addEventListener('pageshow', () => {
      if (isBrowseAllMode()) scrubCurrentUrl();
      updateGlobal(getGarage());
    });
    window.addEventListener('popstate', () => {
      if (isBrowseAllMode()) {
        scrubCurrentUrl();
        updateGlobal(null);
        return;
      }
      const fromUrl = vehicleFromParams();
      if (fromUrl) saveGarage(fromUrl, {silent:true, keepLastResults:true});
      updateGlobal(getGarage());
    });
  }

  function init() {
    if (isBrowseAllMode()) {
      scrubCurrentUrl();
    } else {
      const fromUrl = vehicleFromParams();
      if (fromUrl) {
        saveGarage(fromUrl, {silent:true, keepLastResults:true});
        if (window.location.pathname === '/collections/all') {
          const currentParams = new URLSearchParams(window.location.search);
          const target = resultsUrl(
            fromUrl,
            currentParams.get('btb_category') || '',
            currentParams.get('btb_q') || ''
          );
          const here = `${window.location.pathname}${window.location.search}`;

          // Collection-all is the intentional landing page for BMWs that do not
          // have a dedicated model/engine SEO collection. Do not reload when the
          // current URL is already the canonical finder URL; the previous
          // unconditional replace caused E/F (and other fallback) vehicles to
          // refresh forever.
          if (target !== here) {
            window.location.replace(target);
            return;
          }
        }
      }
    }

    // Product pages first store the selected BMW in My Garage, then remove the
    // finder payload from the visible address. This leaves a clean, shareable
    // /products/<handle>?variant=<id> URL while retaining Shopify theme-preview
    // parameters and the customer's saved vehicle context.
    if (/^\/products\/[^/?#]+/.test(window.location.pathname)) {
      scrubCurrentUrl();
    }

    // Keep My Garage authoritative during collection navigation. System
    // collections (Suspension, Brakes, Intake, etc.) are routed back through the
    // selected BMW's own model landing collection with a category filter. That
    // prevents sibling-chassis products from being mixed into results and keeps
    // the full exact model variant encoded in the URL.
    if (/^\/collections\/[^/?#]+/.test(window.location.pathname)) {
      const current = new URL(window.location.href);
      const currentVehicle = getGarage();
      const hasVehicleState = current.searchParams.has('btb_vehicle') || current.searchParams.has('btb_chassis');

      if (currentVehicle) {
        const systemCategory = collectionCategory(current.pathname);
        if (systemCategory) {
          const target = resultsUrl(currentVehicle, systemCategory, current.searchParams.get('btb_q') || '');
          const here = `${current.pathname}${current.search}`;
          if (target !== here) {
            window.location.replace(target);
            return;
          }
        } else if (!hasVehicleState) {
          const target = withState(current.toString(), currentVehicle, {preserveContext:true});
          const here = `${current.pathname}${current.search}${current.hash}`;
          if (target && target !== here) {
            window.location.replace(target);
            return;
          }
        }
      }

      // Enforce low-to-high pricing on every normal collection page when the
      // shopper has not explicitly chosen a different sort order.
      if (!current.searchParams.has('sort_by')) {
        current.searchParams.set('sort_by', DEFAULT_SORT);
        window.location.replace(cleanUrlString(current));
        return;
      }
    }

    // Search remains vehicle-aware only while a BMW is actively selected.
    if (window.location.pathname === '/search') {
      const vehicle = getGarage();
      if (vehicle) {
        const q = new URLSearchParams(window.location.search).get('q') || '';
        window.location.replace(resultsUrl(vehicle, '', q));
        return;
      }
    }

    document.querySelectorAll('[data-btb-parts-finder]').forEach(initFinder);
    bindGlobalEvents();
    updateGlobal(getGarage());

    if (window.location.hash === '#btb-parts-finder' || new URLSearchParams(window.location.search).has('btb_change_vehicle')) {
      setTimeout(() => document.querySelector('[data-btb-parts-finder]')?.scrollIntoView({behavior:'smooth', block:'center'}), 150);
    }
  }

  document.addEventListener('btb:garage-change', event => updateGlobal(event.detail));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();

  window.BTBGarage = {
    get:getGarage,
    save:saveGarage,
    clear:clearGarage,
    resultsUrl,
    withState,
    vehicleFromParams,
    vehicleKey,
    label,
    chassisAliases,
    exactChassisCodes,
    sharedPlatformTokens,
    rememberLastResults,
    lastResultsUrl,
    browseAllUrl,
    vehicleLandingPath,
    isBrowseAllMode,
    scrubCurrentUrl
  };
})();
